import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_sellable_bags",
  stages: {
    affected_users: 1,
    main: 2, // User sees sellable baggage
    ddot: 3,
    mdot: 4,
    bf_page: 5,
    sellable_bag_on_upsell: 6,
    multi_travellers: 7,
    solo_travellers: 8
  },
  goals: {
    bag_footer_visible: 1
  },
  defaultStage: 1
});

const trackStages = (isMobile: boolean, travellers?: number) => {
  utils.stages.main();
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (travellers === 1) utils.stages.solo_travellers();
  if (travellers && travellers > 1) utils.stages.multi_travellers();
};

export default { trackStages, ...utils };
